export default {
  recordingStart: 'Début d\'enregistrement',
  recordingEnd: 'Fin d\'enregistrement',
  duration: 'Durée',
  launchedBy: 'Lancé par',
  eventsCount: 'Nombre d\'événements enregistrés',
  concurrentRecordings: '{limit} enregistrements simultanés',
  subheader: 'Enregistrer tous les événements',
  launch: 'Lancement d\'un enregistrement d\'événements',
  stop: 'Arrêter l\'enregistrement des événements',
  stopResending: 'Arrêter de renvoyer',
  inProgress: 'Enregistrement en cours...',
  resendingInProgress: 'Renvoi en cours...',
  viewEventsAndPattern: 'Afficher les événements et le modèle',
  viewPattern: 'Afficher le modèle',
  eventsAreLoading: 'Chargement des événements',
  export: 'Exporter vers JSON',
  applyEventFilter: 'Appliquer le filtre d\'événement',
  eventFilterApplied: 'Filtre d\'événement appliqué',
  filterPatternOptional: 'Le modèle de filtre est optionnel',
  delayBetweenEvents: 'Délai entre les événements',
  resendEvents: 'Renvoyer l\'événement | Renvoyer les événements',
  selectedEventsAreResent: 'Les événements sélectionnés ont été renvoyés',
  launchEventRecording: 'Lancement d\'un enregistrement d\'événements',
  launchEventRecordingDescription: 'Appliquer le modèle de filtre pour les événements enregistrés',
  copyEvent: 'Copier l\'événement dans le presse-papiers',
  eventCopied: 'Événement copié dans le presse-papiers',
};
